import { useQuery } from "@tanstack/react-query";

import { useCurrentCompanyId } from "@/hooks/useCurrentCompanyId";
import { useCurrentJobId } from "@/hooks/useCurrentJobId";
import { guacHttpClient } from "@/lib/http";
import { JobNote, HttpResponse } from "@/types";

export function useGetJobNotes() {
  const currentCompanyId = useCurrentCompanyId();
  const currentJobId = useCurrentJobId();

  return useQuery({
    queryKey: ["job-notes", currentCompanyId, currentJobId],
    queryFn: async () => {
      const path = `companies/${currentCompanyId}/jobs/${currentJobId}/job-notes`;
      const res = await guacHttpClient.get<JobNote[], HttpResponse<JobNote[]>>(
        path,
      );
      return res.data;
    },
  });
}
